import { Pipe, PipeTransform } from "@angular/core";

const DEFAULT = "00:00:00";

@Pipe({
  name: "duration",
})
export class DurationPipe implements PipeTransform {
  transform(time: number): string {
    if (typeof time != "number") return DEFAULT;
    if (time <= 0 || isNaN(time)) return DEFAULT;

    const hours = (time / (60 * 60)) % 24;
    const minutes = (time / 60) % 60;
    const seconds = time % 60;

    return `${this.fixNumber(hours)}:${this.fixNumber(minutes)}:${this.fixNumber(seconds)}`;
  }

  /**
   * Fixing number (adding zero before digit)
   * @param number
   * @return string
   */
  fixNumber(number) {
    number = parseInt(number);
    return number < 10 ? "0" + number : number;
  }
}
